import React from 'react';
import { Box } from '@mui/material';

const PromptCrewBrandName = () => (
  <Box component="span" sx={{ whiteSpace: 'nowrap', color: 'text.primary' }}>
    Prompt<Box component="span" sx={{ color: 'primary.main' }}>Crew</Box>
  </Box>
);

export default PromptCrewBrandName;
